import { Route, Routes } from "react-router-dom";
import { PortfolioInfo } from "./portfolio/PortfolioInfo";
import { AccountInfo } from "./accountSettings/AccountInfo";
import { useRecoilValue } from "recoil";
import { Spinner } from "@goodfill/ui-components";
import { AccountSubheader } from "./AccountSubheader";

import "./Account.styles.scss";
import { CustomerApplicationView } from "./customerApplication/CustomerApplicationView";
import { userAuthState } from "../../state";

export const Account = () => {
  const userStateData = useRecoilValue(userAuthState);

  if (userStateData === null) {
    return <Spinner />;
  }

  return (
    <Routes>
      <Route
        index={true}
        path="settings/*"
        element={
          <div className="page-account-info">
            <AccountSubheader selected="accountSettings" />
            <AccountInfo />
          </div>
        }
      />
      <Route
        path="portfolio/*"
        element={
          <div className="page-account-info">
            <AccountSubheader selected="portfolio" />
            <PortfolioInfo />
          </div>
        }
      />
      <Route path="application/*" element={<CustomerApplicationView />} />
    </Routes>
  );
};
